import classNames from 'classnames'
import { useRouter } from 'next/router'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { MyContainer } from '~/components/ui/MyContainer'
import { toCDNImage } from '~/utils'

export const RankHeader = () => {
  const router = useRouter()

  const navData = [
    {
      name: '同款榜',
      href: '/rank',
    },
    {
      name: '作画榜',
      href: '/rank/picture-count',
    },
    {
      name: '粉丝榜',
      href: '/rank/fans-count',
    },
  ]

  return (
    <div
      className="h-[248px] bg-center bg-cover"
      style={{
        backgroundImage: `url(${toCDNImage('/images/rank/bg@2x.png')})`,
      }}
    >
      <MyContainer>
        <PageCrumbs className="pt-4 !mb-6" hasBack dark title="" />
        <div className="flex justify-center items-center mb-6">
          {navData.map(item => {
            const isActive = item.href === router.pathname

            return (
              <span
                key={item.href}
                onClick={() => router.replace(item.href)}
                className={classNames(
                  'relative text-xl font-semibold text-neutral-900 mx-3 pb-3 cursor-pointer'
                )}
              >
                {item.name}
                {isActive && (
                  <span className="absolute bottom-0 left-0 right-0 mx-auto w-12 h-1 block bg-neutral-900"></span>
                )}
              </span>
            )
          })}
        </div>
      </MyContainer>
    </div>
  )
}
